
const digest = 'a7ea52d04009d5f4227ad9300ffe83fa0a4dc98d947559dde8396ebc0a9491b9';
const classes = {"wrapper":"_wrapper_1i7pa_1","item":"_item_1i7pa_7","content":"_content_1i7pa_19","title":"_title_1i7pa_24","subtitle":"_subtitle_1i7pa_28"};
const css = `._wrapper_1i7pa_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}

._item_1i7pa_7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #eaedf3;
  padding: 20px 0;
  align-items: center;
  gap: 10px;
}
._item_1i7pa_7:first-of-type {
  border-top: 0;
}
._item_1i7pa_7 ._content_1i7pa_19 {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
._item_1i7pa_7 ._content_1i7pa_19 ._title_1i7pa_24 {
  font-size: 14px;
  font-weight: 500;
}
._item_1i7pa_7 ._content_1i7pa_19 ._subtitle_1i7pa_28 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  